var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row flex-center q-mt-xl q-mb-xs"},[_c('div',{staticClass:"flex flex-center col-12"},[_c('img',{attrs:{"src":_vm.logo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }